import { memo, useState } from 'react'
import Backdrop from '@mui/material/Backdrop'
import Modal from '@mui/material/Modal'
import Fade from '@mui/material/Fade'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { BigNumber } from '@ethersproject/bignumber'
import './card.scss'

import { QrReader } from 'react-qr-reader';
import QRCode from "react-qr-code";
import { QRCodeCanvas } from 'qrcode.react'

import QrCodeIcon from '@mui/icons-material/QrCode';
import CloseIcon from '@mui/icons-material/Close';
import CameraIcon from '@mui/icons-material/Camera';
import { Grid } from '@mui/material'

const Card = (props: {
    account: string,
    cointitle: string
    gifttitle: string
    imgurl: string
    opacity?: string
    copycontract?: string
    giftmoney?: BigNumber
    buttonname: string
    reward?: string
    background?: string
    claim?: (address: string | undefined, amount: string | undefined) => void
    sendFunc?: (address: string | undefined, amount: string | undefined) => void
    copyAddress?: () => void
}) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#000000',
        border: '1px solid #2a2d3c',
        borderRadius: '20px',
        boxShadow: 24,
        p: 4,
    }

    const styleb = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#000000',
        border: '1px solid #2a2d3c',
        borderRadius: '20px',
        boxShadow: 24,
        pl: 4,
        pr: 4,
        pt: 10,
        pb: 10,
    }

    const {
        account, 
        cointitle,
        gifttitle,
        imgurl,
        copycontract,      
        giftmoney,
        opacity,
        buttonname,
        reward,
        background,
        claim,
        sendFunc,
        copyAddress,
    } = props

    const [opena, setOpena] = useState(false)
    const [transferAddress, setTransferAddress] = useState('')
    const [transferAmount, setTransferAmount] = useState('')
    const [copied, setCopied] = useState(false)
    const handleOpena = () => claim && setOpena(true)
    const handleClosea = () => setOpena(false)

    const [openb, setOpenb] = useState(false)
    const handleOpenb = () => claim && setOpenb(true)
    const handleCloseb = () => setOpenb(false)
    const [showQrScan, setShowQrScan] = useState(false);
    const openQrScanner = () => {
        setTransferAddress('');
        setShowQrScan(true)
    };
    const closeQrScanner = () => setShowQrScan(false);
    const [camera, setCamera] = useState('environment');
    const switchCamera = () => {
        if (camera == 'environment') {
            setCamera('user');
        } else {
            setCamera('environment')
        }
        setShowQrScan(false);
    }

    const [openc, setOpenc] = useState(false)
    const handleOpenc = () => claim && setOpenc(true)
    const handleClosec = () => setOpenc(false)

    return (
        <div>
            <Box sx={{ flexGrow: 1, marginBottom: '15px', padding: '10px'}} className={`coin-total ${opacity}`}>

                    <Grid item sm={4} xs={5} sx={{ marginBottom: '0px' }}>
                        <img className='coin-img' src={imgurl} alt='imgs' style={{ width: '88%', textShadow: '1px 1px 0px rgba(0, 0, 0)', }} />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Grid container spacing={1} className='margin-top-device'>
                                <Grid item xs={12}>
                                    <p style={{
                                        color: '#FFC600', textShadow: '1px 1px 0px rgba(0, 0, 0)',
                                        fontSize: '1.5em',
                                        letterSpacing: '0.15em'
                                    }}
                                        className='card-title'
                                    >
                                        {cointitle}{' '}
                                        {copycontract && (
                                            <img
                                                className='coin-number-contract'
                                                src={copycontract}
                                                onClick={() => { if (copyAddress) copyAddress() }}
                                            />
                                        )}
                                    </p>
                                </Grid>
                                <Grid item xs={0}>
                                    {/* <p style={{
                                        color: '#FFC600',
                                        fontSize: '1.5em',
                                        letterSpacing: '0.1em',
                                        textAlign: 'right',
                                    }}
                                        className='card-title'
                                    >
                                        <img
                                            className='coin-number-symbol'
                                            src='./img/symbol.png'
                                        />
                                        <span>
                                            {(Number(coinmoney)).toFixed(2)}
                                        </span>
                                    </p> */}
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}  style={{ marginBottom: '0px' }} className='margin-top-device'>
                                <Grid item xs={0}>
                                    <p style={{
                                        fontSize: '1.5em',
                                        letterSpacing: '0.15em',
                                        color: '#D4AF37', textShadow: '1px 1px 0px rgba(0, 0, 0)',
                                    }}
                                        className='card-sub-title'
                                    >
                                        <span>{gifttitle}</span>
                                    </p>
                                </Grid>
                                <Grid item xs={0}>
                                    <p style={{
                                        color: '#D4AF37',
                                        fontSize: '1.5em',
                                        letterSpacing: '0.15em',
                                        textAlign: 'right', textShadow: '1px 1px 0px rgba(0, 0, 0)',
                                    }}
                                        className='card-sub-title'
                                    >
                                        
					    
					    
				{giftmoney && (
				    <>
				        <span className='coin-number-symbol'>✠</span>{' '}
				        <span>
				            {(
				                Number(giftmoney) / 1e18 || 0
				            ).toFixed(2)}
				        </span>{' '}
				    </>
				)}


					    
                                    </p>                      
                                </Grid>
                            </Grid>
                              <Grid container spacing={1} style={{ marginBottom: '0px' }} className='margin-top-device'justifyContent="LEFT">


                                    <Grid item xs={6}>
                                        <button
                                            className='coin-button-receive'
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setOpenb(true)
                                            }}
                                        >
                                            {'RECEIVE G✠LD'}
                                        </button>
                                    </Grid>

                                        <Grid item xs={6}>
                                        <button
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                setOpenc(true)
                                            }}
                                            className='coin-button-gift'
                                        >
                                            {'SEND G✠LD'}
                                    </button>
                                </Grid>


                            </Grid>
                        </Box>
                    </Grid>


            </Box>
								
                                
						

                <Box sx={{ flexGrow: 1, padding: '10px' }} className={`coin-total ${opacity}`}>

				 <Grid container columns={12} style={{ }}>
				  <Grid item xs={12}>
                                    <p style={{
                                        color: '#FFC600',
                                        fontSize: '1.5em',
                                        letterSpacing: '.1em',
                                        textAlign: 'CENTER', marginBottom: '15px', textShadow: '1px 1px 0px rgba(0, 0, 0)',
                                    }}
                                        className='card-title'
                                    >
                                        {`UPCOMING LOCAL FIRST G✠LD CURRENCIES`}{' '}

                                    </p>
                                </Grid>

				
                                <Grid item sm={2.5} xs={2} sx={{ marginBottom: '0px' }}>
                                        <img className='coin-img' src='/img/CAROLINIUM.png' alt='CAROLINIUM' style={{ width: '88%' }} />
                                </Grid>

                              <Grid item item sm={3.5} xs={4}>
                                    <p style={{
                                        color: '#FFC600',
                                        fontSize: '1.2em',
                                        letterSpacing: '.1em',
                                        textAlign: 'LEFT', marginBottom: '0px', textShadow: '1px 1px 0px rgba(0, 0, 0)',
                                    }}
                                        className='card-title'
                                    >
                                        {`CAROLINIUM G✠LD`}{' '}

                                    </p>
                                </Grid>

                                     <Grid item sm={2.5} xs={2} sx={{ marginBottom: '0px' }}>
                                            <img className='coin-img' src='/img/MONTANIUM.png' alt='MONTANIUM' style={{ width: '88%' }} />
                                    </Grid>

                                <Grid item sm={3.5} xs={4}>
                                    <p style={{
                                        color: '#FFC600',
                                        fontSize: '1.2em',
                                        letterSpacing: '.1em',
                                        textAlign: 'LEFT', marginBottom: '15px', textShadow: '1px 1px 0px rgba(0, 0, 0)',
                                    }}
                                        className='card-title'
                                    >
                                        {`MONTANIUM G✠LD`}{' '}

                                    </p>
                                </Grid>

				</Grid>
                </Box>



            <Modal
                aria-labelledby='transition-modal-title'
                aria-describedby='transition-modal-description'
                open={openb}
                onClose={handleCloseb}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
  timeout: 500,
  sx: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)' // or 'rgba(0, 0, 0, 0.93)' for even darker
  }
}}

            >
                
		    
		    
		    
		   <Fade in={openb}>
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <QRCodeCanvas
      value={account?.toUpperCase() || ''}
      size={200}
      bgColor="transparent"
      fgColor="#ffc600"
      includeMargin={false}
    />
    <div
      onClick={() => {
        if (account) {
          navigator.clipboard.writeText(account);
          setCopied(true);
          setTimeout(() => {
            setCopied(false);
            handleCloseb();
          }, 1500);
        }
      }}
      title="Click to copy"
      style={{
        marginTop: '20px',
        color: '#ffc600',
        fontSize: '1.2em',
        textAlign: 'center',
        cursor: 'pointer',
        textTransform: 'uppercase',
        border: '1px solid #ffc600',
        borderRadius: '9999px',
        padding: '8px 20px',
        backgroundColor: 'rgba(0,0,0,0.5)',
      }}
    >
      {copied
        ? 'Copied'
        : `${account?.toUpperCase()?.slice(0, 6)}...${account?.slice(-4)}`}
    </div>
  </div>
</Fade>





		    
            </Modal>

{openc && (
  <div
    className="custom-overlay"
    onClick={handleClosec}
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 1000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '16px',
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{ width: '100%', maxWidth: '400px' }}
    >
      <p
        className="send-title"
        style={{
          color: '#ffc600',
          fontSize: '1.5rem',
          fontWeight: 'bold',
          letterSpacing: '0.2em',
          marginBottom: '24px',
          textAlign: 'center',
        }}
      >
        SEND G✠LD
      </p>

      <TextField
        fullWidth
        label="G✠LD AMOUNT"
        value={transferAmount}
        onChange={(e) => setTransferAmount(e.target.value)}
        sx={{ mb: 3 }}
        InputProps={{
          style: {
            backgroundColor: 'transparent',
            borderRadius: '999px',
            color: '#ffc600',
            border: '1px solid #ffc600',
            padding: '12px 20px',
          },
        }}
        InputLabelProps={{
          style: {
            color: '#ffc600',
          },
        }}
      />

      <Box sx={{ position: 'relative', width: '100%' }}>
        <TextField
          fullWidth
          label="ADDRESS"
          value={transferAddress}
          onChange={(e) => setTransferAddress(e.target.value)}
          sx={{ mb: 5 }}
          InputProps={{
            style: {
              backgroundColor: 'transparent',
              borderRadius: '999px',
              color: '#ffc600',
              border: '1px solid #ffc600',
              padding: '12px 20px',
            },
          }}
          InputLabelProps={{
            style: {
              color: '#ffc600',
            },
          }}
        />
        <QrCodeIcon
          onClick={openQrScanner}
          style={{
            position: 'absolute',
            right: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#ffc600',
            cursor: 'pointer',
          }}
        />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 3 }}>
        <Button
          onClick={() => sendFunc?.(transferAddress, transferAmount)}
          variant="outlined"
          sx={{
            border: '1px solid #ffc600',
            color: '#ffc600',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            borderRadius: '999px',
            px: 4,
          }}
        >
          Confirm
        </Button>
        <Button
          onClick={handleClosec}
          variant="outlined"
          sx={{
            border: '1px solid #ffc600',
            color: '#ffc600',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            borderRadius: '999px',
            px: 4,
          }}
        >
          Cancel
        </Button>
      </Box>
    </div>
  </div>
)}
            


            {
                showQrScan
                    ?
                    <Box style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        // backgroundColor:'#fff',
                        zIndex: 999999,
                        width: '50%',
                    }}>
                        <CloseIcon
                            onClick={closeQrScanner}
                            style={{
                                color: '#fff',
                                cursor: 'pointer',
                                position: 'absolute',
                                zIndex: 1,
                                right: 0,
                                width: '27px'
                            }}
                        />
                        <CameraIcon
                            onClick={switchCamera}
                            style={{
                                color: '#fff',
                                cursor: 'pointer',
                                position: 'absolute',
                                zIndex: 1,
                                left: 0,
                                width: '27px'
                            }}
                        />
                        <QrReader
                            constraints={{ facingMode: camera }}
                            onResult={(result, error) => {
                                if (!!result) {
                                    setTransferAddress(result.getText().replace('ethereum:', '').slice(0, 42));
                                    closeQrScanner();
                                }

                                if (!!error) {
                                    console.info(error);
                                }
                            }}
                        />
                    </Box>
                    :
                    ''
            }
        </div>
    )
}
export default memo(Card)
